import { render, staticRenderFns } from "./editInsurance.vue?vue&type=template&id=a73b4d18&scoped=true"
import script from "./editInsurance.vue?vue&type=script&lang=js"
export * from "./editInsurance.vue?vue&type=script&lang=js"
import style0 from "./editInsurance.vue?vue&type=style&index=0&id=a73b4d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73b4d18",
  null
  
)

export default component.exports